module.exports = __webpack_public_path__ + "static/video-bg-1-1-dfe7fc1e03dd21474bbdecb3d35f6cb2.jpg";